<template>
  <div class="maker-details-box">
    <Swipe class="my-swipe" ref="swipe" @change="onChange">
      <SwipeItem v-for="item, index in imgs" :key="index">
        <div class="swipe-pic"><img class="swipe-img" v-lazy="`${item}?imageView2/1/w/350/h/350`"
            @click.stop="showImagePreview(imgs, index)" /></div>
      </SwipeItem>
      <template #indicator>
        <div class="custom-indicator"><span>{{ currentImg + 1 }}/</span><i>{{ imgs.length }}</i></div>
      </template>
    </Swipe>
    <div class="goods-info">
      <span class="price-box">$4<i>.33/pcs</i><i>≥1 pcs</i></span>
      <span class="title-box">Wholesale Rhinestone Hollow Trapezoidal Geometric Earrings</span>
      <span class="hint-box">Material type: stainless steel | Product number: 10358JZ-0023</span>
    </div>
    <div class="goods-cz">
      <div style="align-items: normal;">
        <span>Color：</span>
        <div class="pic" :class="!click1 ? 'active' : ''" @click="click1 = !click1">
          <img src="https://xhdata.wan4.com/wsw-pc-161.png?imageView2/1/w/350/h/350">
          <svg v-if="click1" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path d="M26 26V0L0 26H26Z" fill="#6937E3" />
            <path d="M12 17.6923L16.2 22L24 14" stroke="white" stroke-width="2.4" />
          </svg>
        </div>
      </div>
      <div>
        <span>Material：</span><span class="cz" @click="click2 = !click2" :class="!click2 ? 'active' : ''">304 stainless
          Steel
          <svg v-if="click2" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path d="M26 26V0L0 26H26Z" fill="#6937E3" />
            <path d="M12 17.6923L16.2 22L24 14" stroke="white" stroke-width="2.4" />
          </svg></span>
      </div>
      <div>
        <span>Quantity：</span>
        <Stepper min="0" :max="100" integer v-model="buyQty" @change="changeBuyQty" @overlimit="checkBuyQty"
          @plus="onPlus" @minus="onPlus" @blur="onPlus" :disable-minus="buyQty <= 0">
        </Stepper>

        <i>Stock: 100pcs</i>
      </div>
    </div>

    <div class="like-box">
      <span>You may also like</span>
      <div class="gb-list-box">
        <div class="gb-item-box" v-for="item, index in likeList" :key="index">
          <div class="gb-pic">
            <img v-lazy="`${item.img}?imageView2/1/w/400/h/400`">
          </div>
          <span class="overflow">{{ item.title }}</span>
          <i>${{ $fn.initPrice(item.price, 0) }}<i>{{ $fn.initPrice(item.price, 1) }}</i></i>
        </div>
      </div>

    </div>
    <div class="bottom-box">
      <div class="bottom-hint">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path
              d="M31.875 17C31.875 8.78477 25.2152 2.125 17 2.125C8.78477 2.125 2.125 8.78476 2.125 17C2.125 25.2152 8.78476 31.875 17 31.875C25.2152 31.875 31.875 25.2152 31.875 17ZM18.0625 8.50064V20.1875H15.9375V8.50064H18.0625ZM15.7129 23.375H18.2629V25.925H15.7129V23.375Z"
              fill="#FF7D00" />
          </svg>
          <span>
            正在预览“克隆后的外贸网站”，内容仅供参考，非上线效果！
          </span>
        </div>
        <div>
          <span @click="$router.push('/advert/advert1')">去克隆我的外贸网站</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path
              d="M13.7288 26.4768L11.7754 24.5234L19.2987 17.0001L11.7754 9.47681L13.7288 7.52342L23.2055 17.0001L13.7288 26.4768Z"
              fill="#FF7D00" />
          </svg>
        </div>
      </div>
      <div class="btn-box">
        <Button>Buy Now</Button>
        <Button>Add To Cart</Button>
      </div>
    </div>
  </div>

</template>
<script>
import { Swipe, SwipeItem, ImagePreview, Stepper, Button } from 'vant';
export default {
  name: 'MakerDetails',
  components: {
    Swipe, SwipeItem, Stepper, Button
  },
  props: {},
  data() {
    return {
      buyQty: '',
      imgs: [
        'https://xhdata.wan4.com/wsw-pc-161.png',
        'https://xhdata.wan4.com/wsw-pc-162.png',
        'https://xhdata.wan4.com/wsw-pc-163.png',
        'https://xhdata.wan4.com/wsw-pc-164.png',
        'https://xhdata.wan4.com/wsw-pc-165.png',
      ],
      currentImg: 0,
      click1: true,
      click2: true,
      likeList: [{
        img: 'https://xhdata.wan4.com/wsw-pc-131.png',
        title: 'Wholesale Irregular Texture Hollow...',
        price: '311'
      },
      {
        img: 'https://xhdata.wan4.com/wsw-pc-126.png',
        title: 'Wholesale Cute Christmas Jewelry...',
        price: '149'
      },
      {
        img: 'https://xhdata.wan4.com/wsw-pc-127.png',
        title: 'Hot Sale Stainless Steel Christmas...',
        price: '226'
      },
      {
        img: 'https://xhdata.wan4.com/wsw-pc-128.png',
        title: 'Trendy Brass Colorful Zircon Christ...',
        price: '447'
      },
      {
        img: 'https://xhdata.wan4.com/wsw-pc-129.png',
        title: 'Trendy Wholesale Jewelry Christm...',
        price: '178'
      },
      {
        title: 'New Arrival Jewelry Copper Christ...',
        img: 'https://xhdata.wan4.com/wsw-pc-160.png',
        price: '410',
      },
      ]
    }
  },

  created() {
  },
  methods: {//查看大图
    showImagePreview(imgs, index) {
      ImagePreview({
        images: imgs,
        startPosition: index
      })
    },
    // 底部菜单
    onChange(e) {
      this.currentImg = e;
    },
    // 步进器
    changeBuyQty() {
      this.$nextTick(() => {
        let maxNum = 100;
        this.buyQty = Number(this.buyQty)
        if (this.buyQty <= 0) {
          this.buyQty = 0;
        } else {
          if (maxNum < this.buyQty) {
            this.buyQty = maxNum;
            this.$toastUtil.show('The maximum quantity of this product is ' + Number(this.buyQty).toLocaleString())
          }
        }

      })
    },
    minNum(){
      return 10
    },
    maxNum(){
      return 100
    },
    //校验购买数量
    checkBuyQty(e) {
      // 'minus' 'plus'
      if (this.minNum() == 0) {
        if (e == 'plus') {
          this.$toastUtil.show('库存不足，无法添加');
        }
      } else {
        if (this.minNum() >= this.buyQty) {
          if (e == 'plus') {
            this.$toastUtil.show('库存不足，无法满足起订量');
          }
        } else if (this.maxNum() <= this.buyQty) {
          if (e == 'plus') {
            this.$toastUtil.show('The maximum quantity of this product is '+Number(this.buyQty).toLocaleString());
          }
        }
      }
    },
    // 加数量
    onPlus() {
      this.$nextTick(() => {
        let buyQty = this.buyQty;
        let minNum = 0;
        if (buyQty != 0 && buyQty < minNum) {
          this.buyQty = 0
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.maker-details-box {
  display: flex;
  flex-direction: column;
  padding-bottom: 250px;

  .my-swipe {
    width: 100vw;
    height: 100vw;

    .swipe-pic {
      width: 100vw;
      height: 100vw;
      overflow: hidden;
      position: relative;

      .swipe-img {
        width: calc(100vw + 4px);
        height: calc(100vw + 4px);
        position: absolute;
        top: -2px;
        left: -2px;
        object-fit: cover;
      }
    }


    .custom-indicator {
      min-width: 98px;
      height: 46px;
      padding: 0 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #0000004D;
      position: absolute;
      bottom: 40px;
      right: 0;
      border-radius: 80px 0px 0px 80px;

      >span {
        color: #FFF;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        padding-bottom: 2px;
      }

      >i {
        color: #FFF;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        padding-bottom: 2px;
        margin-top: 5px;
      }
    }
  }

  .goods-info {
    display: flex;
    flex-direction: column;
    background: #fff;
    padding-left: 32px;
    padding-bottom: 24px;

    .price-box {
      color: #F53F3F;
      font-family: Arial;
      font-size: 52px;
      font-style: normal;
      font-weight: bold;
      line-height: 52px;
      margin: 24px 0 0;

      >i {
        color: #F53F3F;
        font-family: Arial;
        font-size: 24px;
        font-style: normal;
        font-weight: bold;
        line-height: 52px;
      }

      >i+i {
        color: #FF7D00;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 34px;
        margin-left: 12px;
      }
    }

    .title-box {
      color: #111;
      font-size: 28px;
      font-style: normal;
      font-weight: bold;
      line-height: 40px;
      margin: 12px 0 0;
    }

    .hint-box {
      color: #999;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
      margin: 8px 0 0;
    }
  }

  .goods-cz {
    display: flex;
    flex-direction: column;
    margin-top: 6px;
    background: #fff;
    padding: 24px 32px 0;

    >div {
      display: flex;
      align-items: center;
      margin-bottom: 32px;

      >span {
        color: #666;
        text-align: right;
        font-size: 26px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
      }

      >i {
        margin-left: 16px;
        color: #666;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 40px;
      }

      .cz {
        color: #6937E3;
        font-size: 28px;
        font-style: normal;
        font-weight: bold;
        border-radius: 4px;
        border: 4px solid #6937E3;
        background: #F1E4FF;
        height: 56px;
        display: flex;
        align-items: center;
        padding: 0 40px;
        position: relative;
        overflow: hidden;

        >svg {
          position: absolute;
          bottom: -1px;
          right: -1px;
          width: 26px;
          height: 26px;
        }
      }

      .pic {
        width: 160px;
        height: 160px;
        border-radius: 4px;
        border: 4px solid #6937E3;
        position: relative;
        overflow: hidden;

        >svg {
          position: absolute;
          bottom: -1px;
          right: -1px;
          width: 26px;
          height: 26px;
        }

        >img {
          width: 100%;
          height: 100%;
        }
      }

      .active {
        border: 4px solid #CCC;
        background: #fff;
        color: #333;
      }
    }
  }

  .like-box {
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 28px 24px;
    margin-top: 12px;

    >span {
      color: #6937E3;
      font-size: 32px;
      font-style: normal;
      font-weight: 600;
      line-height: 44px;
    }

    .gb-list-box {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 18px 14px;
      background: #fff;

      .gb-item-box {
        display: flex;
        flex-direction: column;
        width: 100%;
        overflow: hidden;
        border-radius: 12px;

        .gb-pic {
          width: 100%;
          position: relative;
          overflow: hidden;

          &::before {
            content: '';
            display: block;
            padding-bottom: 100%;
            /* 使高度等于宽度 */
          }

          >img {
            width: calc(100% + 4px);
            height: calc(100% + 4px);
            position: absolute;
            top: -2px;
            left: -2px;
          }
        }

        >span {
          color: #333;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 34px;
          margin-left: 10px;
        }

        >i {
          color: #F53F3F;
          font-family: Arial;
          font-size: 34px;
          font-style: normal;
          font-weight: 700;
          line-height: 48px;
          margin-top: 6px;
          margin-left: 10px;
          margin-bottom: 18px;

          >i {
            color: #F53F3F;
            font-family: Arial;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 48px;
          }
        }
      }
    }
  }

  .bottom-box {
    position: fixed;
    bottom: 0;
    padding-bottom: calc(env(safe-area-inset-bottom));
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    background: #fff;

    .bottom-hint {
      background: #FFE4BA;
      display: flex;
      flex-direction: column;
      padding: 12px 26px;

      >div {
        display: flex;
        align-items: center;

        >svg {
          width: 34px;
          height: 34px;
        }

        >span {
          color: #FF7D00;
          font-size: 24px;
          font-style: normal;
          font-weight: 600;
          line-height: 34px;
          margin-left: 10px;
        }
      }

      >div+div {
        justify-content: center;
        margin-top: 4px;

        >span {
          text-decoration-line: underline;
        }
      }
    }

    .btn-box {
      display: flex;
      height: 112px;
      padding: 0 19px;
      align-items: center;

      >Button {
        flex: 1;
        border-radius: 94px;
        border: 2px solid #6937E3;
        background: #F1ECFF;
        margin: 13px;
        color: #6937E3;
        font-size: 28px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      >Button+Button {
        color: #fff;
        background: #6937E3;
      }

    }
  }


}
</style>